export default __webpack_public_path__ + "static/media/Obj.49a111db.svg";